import { Divider, Table, Typography } from "antd"
import { useCollection } from "../../../hooks/useCollection"
import { useAuthContext } from "../../../hooks/useAuthContext"
import { CloseCircleFilled } from "@ant-design/icons"

//Renames Router Dom "Link" as Direction
import moment from "moment"
import ShowSavedPricesDrawer from "../../../components/Manager/Prices/ShowSavedPricesDrawer"
import useInteractiveTableFilters from "../../../components/Filters/InteractiveFilters"
import PriceDisplay from "../../../components/utils/PriceDisplay"

const filterConfig = [
  { key: "client", dataIndex: "client" },
  { key: "product", dataIndex: ["product", "productName"] },
  { key: "filterGroup", dataIndex: "filterGroup" },
]

const { Title, Link, Text } = Typography

export default function UnapprovedPrices() {
  const { user } = useAuthContext()
  const { loading, data } = useCollection(
    "priceCalculation",
    ["user", "==", user.uid],
    ["aproved", "==", false]
  )

  const [appliedFilters, setAppliedFilters, generateFilters] = useInteractiveTableFilters(
    data,
    filterConfig
  )

  //Controls the state of columns
  const columns = [
    {
      title: "Clients",
      dataIndex: "client",
      filters: generateFilters("client", "client"),
      onFilter: (value, record) => record.client === value,
      filterSearch: true,
    },
    {
      title: "Filter Group",
      dataIndex: "filterGroup",
      filterSearch: true,
      filters: generateFilters("filterGroup", "filterGroup"),
      onFilter: (value, record) => record.filterGroup === value,
      render: (value, record) => {
        if (record.hasFilterGroup) {
          return record.filterGroup
        } else {
          return "none"
        }
      },
    },

    {
      title: "Product",
      dataIndex: ["product", "productName"],
      filters: generateFilters("product", "productName"),
      filterSearch: true,
      onFilter: (value, record) => record.product.productName === value,
    },
    {
      title: "Price",
      dataIndex: "price",
      sorter: (a, b) => a.price - b.price,
      render: (value, record) => {
        return <PriceDisplay data={record} />
      },
    },
    {
      title: "Width",
      dataIndex: "labelWidth",
      sorter: (a, b) => a.labelWidth - b.labelWidth,
    },
    {
      title: "Height",
      dataIndex: "labelHeight",
      sorter: (a, b) => a.labelHeight - b.labelHeight,
    },
    {
      title: "Material",
      dataIndex: "material",
      sorter: (a, b) => a.material - b.material,
    },
    {
      title: "Count",
      dataIndex: "labelCount",
      sorter: (a, b) => a.labelCount - b.labelCount,
    },
    {
      title: "Attachment",
      dataIndex: ["product", "productFileUrl"],
      align: "center",
      render: (value) => (
        <Link type="text" rel="noreferrer" target="_blank" href={value}>
          {value ? "Link" : ""}
        </Link>
      ),
    },
    {
      title: "Details",
      align: "center",
      render: (value) => <ShowSavedPricesDrawer appliedFilters={appliedFilters} data={value} />,
    },

    {
      title: "Created",
      dataIndex: ["date", "created"],
      sorter: (a, b) => a.date.create.seconds - b.date.create.seconds,
      render: (value) => (
        <>
          <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
        </>
      ),
    },
  ]

  return (
    <div style={{ marginTop: "15px" }}>
      <Title level={3} style={{ marginLeft: "18px" }}>
        <CloseCircleFilled /> <Divider type="vertical" />
        Unaproved Prices
      </Title>
      <Table
        bordered
        style={{ margin: "15px" }}
        size="small"
        columns={columns}
        loading={loading}
        dataSource={data && data}
        rowKey={(record) => record.id}
        pagination={{ defaultPageSize: "15" }}
        onChange={(pagination, filters) => {
          setAppliedFilters({
            client: filters.client || [],
            product: filters.product || [],
            filterGroup: filters.filterGroup || [],
          })
        }}
      />
    </div>
  )
}
